import { useState } from 'react';

export default function BitradexWithdrawalPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      setIsScrolled(window.scrollY > 50);
    });
  }

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <a href="/" className="flex items-center gap-2 sm:gap-3 cursor-pointer">
              <img 
                alt="BitradeX" 
                className="h-6 w-6 sm:h-7 sm:w-7 object-contain flex-shrink-0" 
                src="https://static.readdy.ai/image/c283ebba76f2231788b6e8a6bcedfde5/67bb25588a3178cfd4ccfa485ed4ebfb.jpeg"
              />
              <span className="text-sm sm:text-base font-semibold text-slate-800 leading-tight">
                <span className="hidden sm:inline">AI Crypto Support for BitradeX</span>
                <span className="sm:hidden">AI Crypto Support<br />for BitradeX</span>
              </span>
            </a>
            <nav className="hidden md:flex items-center space-x-6">
              <a 
                href="/"
                className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors whitespace-nowrap cursor-pointer"
              >
                ホーム
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-24 pb-20 px-4 sm:px-6 lg:px-8">
        <article className="max-w-4xl mx-auto">
          {/* H1 */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-800 leading-tight mb-12 sm:mb-16 tracking-tight">
            BitradeXは出金できる？100万円を実際に移動した検証動画
          </h1>

          {/* Section 1: Video */}
          <section className="mb-16 sm:mb-20">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-800 mb-6 sm:mb-8 tracking-tight">
              実際に100万円を出金した検証動画
            </h2>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://www.youtube.com/embed/Hpw3kWANlvQ"
                  title="BitradeX出金検証動画"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </section>

          {/* Section 2: 動画の意味・検証意図 */}
          <section className="mb-16 sm:mb-20">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-800 mb-6 sm:mb-8 tracking-tight">
              動画の意味・検証意図
            </h2>
            <div className="prose prose-lg max-w-none space-y-5 text-slate-700 leading-relaxed">
              <p className="text-base sm:text-lg font-bold text-slate-800">
                ◆動画の意味・検証意図
              </p>
              <p className="text-base sm:text-lg">
                BitradeXは出金できない？詐欺案件ではないのか？
              </p>
              <p className="text-base sm:text-lg">
                という不安を解決していきます。
              </p>
              <p className="text-base sm:text-lg">
                今回の動画は、メタマスクという私の個人ウォレット（財布）へ100万円を出金をした内容になっています。
              </p>
              <p className="text-base sm:text-lg">
                ※BitradeX→日本の取引所への出金も操作方法は一緒です。<br />
                別動画では、<br />
                BitradeX→日本の取引所（Bitbank）へ出金方法→日本円（JPY）にして日本の銀行口座へ着金させる。
              </p>
              <p className="text-base sm:text-lg">
                という一連の流れの動画も撮影しています。<br />
                その動画では出金のやり方を説明していて、実際に資金の移動はしていませんので、まずは今回の動画を見て、出金ができるという証明を確認してみてください。
              </p>
              <p className="text-base sm:text-lg">
                動画を見てもわからない方は、個人LINEへ連絡してください。<br />
                不明点を解決しながら、一緒に行いましょう。
              </p>
            </div>
          </section>

          {/* Section 3: 動画詳細 */}
          <section className="mb-16 sm:mb-20">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-800 mb-6 sm:mb-8 tracking-tight">
              動画詳細
            </h2>
            <div className="prose prose-lg max-w-none space-y-5 text-slate-700 leading-relaxed">
              <p className="text-base sm:text-lg font-bold text-slate-800">
                ◆動画詳細
              </p>
              <p className="text-base sm:text-lg">
                BitradeXのAibotからは、毎日0.5％の利益を得ています。<br />
                その利益を100万円分貯め、今回出金しました。<br />
                元本回収が目的です。
              </p>
              <p className="text-base sm:text-lg">
                これから皆さんはBitradeXAi運用にて毎日利益を出していきます。
              </p>
              <p className="text-base sm:text-lg">
                しかしその利益の引き出し方法がわからなかったら日本円にできません。<br />
                元本も戻せません。
              </p>
              <p className="text-base sm:text-lg">
                ですので、実際に私が100万円という金額をBitradeXからメタマスクへ資金移動をした動画になりますので、しっかり勉強してください。
              </p>
            </div>
          </section>

          {/* Section 4: 注意点・補足説明 */}
          <section className="mb-16 sm:mb-20">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-800 mb-6 sm:mb-8 tracking-tight">
              注意点・補足説明
            </h2>
            <div className="prose prose-lg max-w-none space-y-5 text-slate-700 leading-relaxed">
              <p className="text-base sm:text-lg font-bold text-slate-800">
                ◆注意点・補足説明
              </p>
              <p className="text-base sm:text-lg">
                最もリスクが高い「送金ミス」を防ぐための必須項目です。
              </p>
              <div className="bg-amber-50 border-l-4 border-amber-500 rounded-lg p-5 sm:p-6 my-6">
                <p className="text-base sm:text-lg font-bold text-slate-800 mb-3">
                  ①送金アドレスの誤入力（最重要）:
                </p>
                <p className="text-base sm:text-lg">
                  手入力は絶対に避けてください。必ず「コピー＆ペースト」または「QRコード読み取り」を使用する。
                </p>
                <p className="text-base sm:text-lg mt-3">
                  1文字でも間違えると資金は失われ、原則として返還されません。
                </p>
              </div>
              <div className="bg-amber-50 border-l-4 border-amber-500 rounded-lg p-5 sm:p-6 my-6">
                <p className="text-base sm:text-lg font-bold text-slate-800 mb-3">
                  ②ネットワーク（チェーン）の選択:
                </p>
                <p className="text-base sm:text-lg">
                  送金元と送金先で同じネットワーク（BNBチェーン（BEP20）推奨）を選択する必要があります。異なるネットワークを選ぶと資金が消滅します。
                </p>
              </div>
              <div className="bg-amber-50 border-l-4 border-amber-500 rounded-lg p-5 sm:p-6 my-6">
                <p className="text-base sm:text-lg font-bold text-slate-800 mb-3">
                  ③少額でテスト送金:
                </p>
                <p className="text-base sm:text-lg">
                  大きな金額を送る際は、まず最低限の金額で送金が成功するか確認する。
                </p>
              </div>
              <div className="bg-amber-50 border-l-4 border-amber-500 rounded-lg p-5 sm:p-6 my-6">
                <p className="text-base sm:text-lg font-bold text-slate-800 mb-3">
                  ④トラベルルール
                </p>
                <p className="text-base sm:text-lg">
                  日本の取引所からBitradeXへ入金する際は、メタマスクなど外部ウォレットを経由してBitradeXへ入金する作業が必要です。
                </p>
                <p className="text-base sm:text-lg mt-3">
                  しかしそれとは逆に、<br />
                  BitradeXから日本の取引所へ出金する際は、メタマスクなど外部ウォレットを経由せずに、直接日本の取引所へ出金することが可能です。
                </p>
              </div>
            </div>
          </section>

          {/* Section 5: 出金の流れ */}
          <section className="mb-16 sm:mb-20">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-800 mb-6 sm:mb-8 tracking-tight">
              出金の流れ（仮想通貨を日本円にする操作方法）
            </h2>
            <div className="prose prose-lg max-w-none space-y-5 text-slate-700 leading-relaxed">
              <p className="text-base sm:text-lg font-bold text-slate-800">
                ◆出金の流れ
              </p>
              <p className="text-base sm:text-lg">
                仮想通貨を日本円にする操作方法
              </p>
              <div className="bg-slate-50 rounded-xl p-5 sm:p-6 my-6">
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-[#1e3a5f] text-white rounded-full font-bold text-sm">
                      1
                    </div>
                    <div>
                      <p className="text-base sm:text-lg font-bold text-slate-800 mb-2">
                        日本の取引所に資産を移動
                      </p>
                      <p className="text-base sm:text-lg">
                        仮想通貨を、日本国内取引所の自分のアカウントへ送金する
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-[#1e3a5f] text-white rounded-full font-bold text-sm">
                      2
                    </div>
                    <div>
                      <p className="text-base sm:text-lg font-bold text-slate-800 mb-2">
                        売却（換金）
                      </p>
                      <p className="text-base sm:text-lg">
                        「販売所」画面で、対象の仮想通貨（BNB推奨）を売却し、日本円（JPY）に換える。
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-[#1e3a5f] text-white rounded-full font-bold text-sm">
                      3
                    </div>
                    <div>
                      <p className="text-base sm:text-lg font-bold text-slate-800 mb-2">
                        銀行口座の登録
                      </p>
                      <p className="text-base sm:text-lg">
                        本人名義の銀行口座を事前に登録・確認する。
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-[#1e3a5f] text-white rounded-full font-bold text-sm">
                      4
                    </div>
                    <div>
                      <p className="text-base sm:text-lg font-bold text-slate-800 mb-2">
                        日本円の出金申請
                      </p>
                      <p className="text-base sm:text-lg">
                        「入出金」メニューから「日本円」を選び、「出金」をクリック。
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-[#1e3a5f] text-white rounded-full font-bold text-sm">
                      5
                    </div>
                    <div>
                      <p className="text-base sm:text-lg font-bold text-slate-800 mb-2">
                        出金金額を決める
                      </p>
                      <p className="text-base sm:text-lg">
                        出金する金額を入力し、手数料を確認して申請を完了する。
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-[#1e3a5f] text-white rounded-full font-bold text-sm">
                      6
                    </div>
                    <div>
                      <p className="text-base sm:text-lg font-bold text-slate-800 mb-2">
                        出金完了
                      </p>
                      <p className="text-base sm:text-lg">
                        登録した銀行口座へ日本円が振り込まれる（通常、数日かかる場合がある）
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="bg-[#e8f0f7] rounded-2xl p-6 sm:p-8 lg:p-10">
            <div className="text-center space-y-6">
              <h3 className="text-xl sm:text-2xl font-extrabold text-slate-800 tracking-tight">
                出金方法について不明な点がある方へ
              </h3>
              
              <div className="space-y-5">
                {/* Primary CTA */}
                <div>
                  <p className="text-sm sm:text-base text-slate-600 mb-3">登録は無料・数分で完了します</p>
                  <a 
                    href="https://www.bitradex.com/en/account/register?inviteCode=85BXT4" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-[#1e3a5f] text-white text-base sm:text-lg font-bold hover:bg-[#2d4a6f] transition-colors cursor-pointer shadow-md hover:shadow-lg whitespace-nowrap"
                  >
                    無料登録はこちら
                    <div className="w-5 h-5 flex items-center justify-center ml-2">
                      <i className="ri-arrow-right-line text-xl"></i>
                    </div>
                  </a>
                  <p className="text-xs text-slate-500 mt-2">※公式登録ページへ移動します</p>
                  <p className="text-sm text-slate-600 mt-4 leading-relaxed">
                    無料登録後、操作方法や出金方法をLINEにて個別サポートしています。
                  </p>
                </div>

                {/* Secondary CTA */}
                <div className="pt-4">
                  <a 
                    href="https://lin.ee/liB3jhC" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-[#06c755] text-white text-base sm:text-lg font-bold hover:bg-[#05b34c] transition-colors cursor-pointer shadow-md hover:shadow-lg whitespace-nowrap"
                  >
                    <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center mr-2">
                      <i className="ri-line-fill text-xl sm:text-2xl"></i>
                    </div>
                    LINE相談はこちら
                  </a>
                </div>
              </div>
            </div>
          </section>

          {/* Related Information Section */}
          <section className="mt-16 sm:mt-20">
            <h3 className="text-lg sm:text-xl font-extrabold text-slate-800 mb-6 tracking-tight">
              ▼ BitradeX関連情報
            </h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href="/bitradex-deposit" 
                  className="text-base sm:text-lg text-[#1e3a5f] hover:text-[#2d5a87] transition-colors cursor-pointer flex items-center"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-arrow-right-s-line text-lg"></i>
                  </div>
                  入金方法
                </a>
              </li>
              <li>
                <a 
                  href="/bitradex-safety" 
                  className="text-base sm:text-lg text-[#1e3a5f] hover:text-[#2d5a87] transition-colors cursor-pointer flex items-center"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-arrow-right-s-line text-lg"></i>
                  </div>
                  安全性について
                </a>
              </li>
              <li>
                <a 
                  href="/bitradex-seminar-review" 
                  className="text-base sm:text-lg text-[#1e3a5f] hover:text-[#2d5a87] transition-colors cursor-pointer flex items-center"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-arrow-right-s-line text-lg"></i>
                  </div>
                  セミナー潜入調査
                </a>
              </li>
            </ul>
          </section>
        </article>
      </main>

      {/* Footer */}
      <footer className="bg-[#1e3a5f] text-white py-12 sm:py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 sm:gap-12 mb-8 sm:mb-12">
            <div className="space-y-4 sm:space-y-6">
              <a href="/" className="flex items-center space-x-2 cursor-pointer">
                <img 
                  alt="BitradeX" 
                  className="h-8 w-8 object-contain" 
                  src="https://static.readdy.ai/image/c283ebba76f2231788b6e8a6bcedfde5/67bb25588a3178cfd4ccfa485ed4ebfb.jpeg"
                />
                <h3 className="text-lg sm:text-xl font-bold tracking-tight">AI Crypto Support for <span className="font-extrabold">BitradeX</span></h3>
              </a>
              <p className="text-xs sm:text-sm text-slate-300 leading-relaxed">
                <span className="font-semibold text-white">BitradeX</span>の<span className="font-semibold text-white">AIボット</span>取引について、日本人向けに情報を整理し、<br />
                サポートを行う個人運営のサイトです。
              </p>
            </div>
            <div className="space-y-4 sm:space-y-6">
              <div>
                <h4 className="text-xs sm:text-sm font-bold uppercase mb-3">BitradeX関連情報</h4>
                <ul className="space-y-2">
                  <li>
                    <a href="/bitradex-withdrawal" className="text-xs sm:text-sm text-slate-300 hover:text-white transition-colors cursor-pointer">
                      出金方法
                    </a>
                  </li>
                  <li>
                    <a href="/bitradex-deposit" className="text-xs sm:text-sm text-slate-300 hover:text-white transition-colors cursor-pointer">
                      入金方法
                    </a>
                  </li>
                  <li>
                    <a href="/bitradex-safety" className="text-xs sm:text-sm text-slate-300 hover:text-white transition-colors cursor-pointer">
                      安全性について
                    </a>
                  </li>
                  <li>
                    <a href="/bitradex-seminar-review" className="text-xs sm:text-sm text-slate-300 hover:text-white transition-colors cursor-pointer">
                      セミナー潜入調査
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="space-y-4 sm:space-y-6">
              <div>
                <h4 className="text-xs sm:text-sm font-bold uppercase mb-3">免責事項</h4>
                <p className="text-xs text-slate-300 leading-relaxed">
                  本サイトの情報は参考情報であり、投資判断は自己責任で行ってください。<br />
                  損失について当サイトは一切の責任を負いません。<br />
                  本サイトのサポートは、投資助言や利益保証を行うものではありません。
                </p>
              </div>
              <div>
                <h4 className="text-xs sm:text-sm font-bold uppercase mb-3">お問い合わせ</h4>
                <a 
                  href="https://lin.ee/liB3jhC" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="inline-flex items-center text-xs sm:text-sm text-slate-300 hover:text-white transition-colors cursor-pointer"
                >
                  <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mr-2">
                    <i className="ri-line-fill text-base sm:text-lg"></i>
                  </div>
                  LINEでお問い合わせ
                </a>
              </div>
            </div>
          </div>
          <div className="border-t border-white/10 pt-6 sm:pt-8 flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
            <p className="text-xs sm:text-sm text-slate-300">© 2025 AI Crypto Support for BitradeX. All rights reserved.</p>
            <div className="flex items-center space-x-6 text-xs sm:text-sm text-slate-300">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
